export const north_dakota = {
  "38000": "North Dakota",
  "38001": "Adams County",
  "38003": "Barnes County",
  "38005": "Benson County",
  "38007": "Billings County",
  "38009": "Bottineau County",
  "38011": "Bowman County",
  "38013": "Burke County",
  "38015": "Burleigh County",
  "38017": "Cass County",
  "38019": "Cavalier County",
  "38021": "Dickey County",
  "38023": "Divide County",
  "38025": "Dunn County",
  "38027": "Eddy County",
  "38029": "Emmons County",
  "38031": "Foster County",
  "38033": "Golden Valley County",
  "38035": "Grand Forks County",
  "38037": "Grant County",
  "38039": "Griggs County",
  "38041": "Hettinger County",
  "38043": "Kidder County",
  "38045": "LaMoure County",
  "38047": "Logan County",
  "38049": "McHenry County",
  "38051": "McIntosh County",
  "38053": "McKenzie County",
  "38055": "McLean County",
  "38057": "Mercer County",
  "38059": "Morton County",
  "38061": "Mountrail County",
  "38063": "Nelson County",
  "38065": "Oliver County",
  "38067": "Pembina County",
  "38069": "Pierce County",
  "38071": "Ramsey County",
  "38073": "Ransom County",
  "38075": "Renville County",
  "38077": "Richland County",
  "38079": "Rolette County",
  "38081": "Sargent County",
  "38083": "Sheridan County",
  "38085": "Sioux County",
  "38087": "Slope County",
  "38089": "Stark County",
  "38091": "Steele County",
  "38093": "Stutsman County",
  "38095": "Towner County",
  "38097": "Traill County",
  "38099": "Walsh County",
  "38101": "Ward County",
  "38103": "Wells County",
  "38105": "Williams County",
};
